import IRealtimeViewState from "../models/IRealtimeViewState";

export const initialState: IRealtimeViewState = {
    realtimeViewData: {
        data: {
            Length: 0,
            AdType: "iaq",
            Temprature: 0,
            Humidity: 0,
            PMI1: 0,
            PMI25: 0,
            PMI10: 0,
            CO2: 0,
            CO: 0,
            TVOC: 0,
            CH2O: 0,
            AirIndex: 0,
            CreatedAt: "",
        },
        error: null,
        loading: false,
        success: false,
    },
    realtimeViewChartDataState: {
        data: {
            ChartData: [
                {
                    KPIName: "temprature",
                    KPIUnit: "Deg C",
                    Data: []
                },
                {
                    KPIName: "humidity",
                    KPIUnit: "%Rh",
                    Data: []
                },
                {
                    KPIName: "co2",
                    KPIUnit: "ppm",
                    Data: []
                },
                {
                    KPIName: "co",
                    KPIUnit: "ppm",
                    Data: []
                },
                {
                    KPIName: "tvoc",
                    KPIUnit: "ppb",
                    Data: []
                },
                {
                    KPIName: "ch2o",
                    KPIUnit: "ppb",
                    Data: []
                },
                {
                    KPIName: "pmi_2_5",
                    KPIUnit: "ug/m3",
                    Data: []
                }
            ]
        },
        error: null,
        loading: false,
        success: false,
    },
    IIAQSensorThresholdState: {
        data: null,
        success: false,
        error: null,
        loading: false,
    }
};
